import { InjectionToken } from '@angular/core';

export interface InactivityLogoutConfig {
  warningAfterMs?: number;
  logoutAfterWarningMs?: number;
  pauseWhenHidden?: boolean;
  isEnabled?: () => boolean;
  onLogout?: () => void;
}

export const DEFAULT_INACTIVITY_LOGOUT_CONFIG: Required<
  Pick<
    InactivityLogoutConfig,
    'warningAfterMs' | 'logoutAfterWarningMs' | 'pauseWhenHidden' | 'isEnabled'
  >
> &
  InactivityLogoutConfig = {
  warningAfterMs: 15 * 60 * 1000, // 15 minutes
  logoutAfterWarningMs: 5 * 60 * 1000, // 5 minutes
  pauseWhenHidden: false, // false means that the inactivity logout will not be paused when the browser tab is hidden
  isEnabled: () => true,
};

export const INACTIVITY_LOGOUT_CONFIG =
  new InjectionToken<InactivityLogoutConfig>('INACTIVITY_LOGOUT_CONFIG', {
    providedIn: 'root',
    factory: () => DEFAULT_INACTIVITY_LOGOUT_CONFIG,
  });
